import { createFileRoute } from "@tanstack/react-router";
import { TEMPLATE_CHANNEL } from "@offsilo/contracts/automation";
import { z } from "zod";
import { MessageEditor } from "@/features/workflows/MessageEditor";
import { UseInN8nPanel } from "@/features/commcentre/UseInN8n";

const search = z.object({ channel: TEMPLATE_CHANNEL.optional() });

export const Route = createFileRoute("/_app/automations/messages/$template")({
  validateSearch: search,
  component: () => {
    const { template } = Route.useParams();
    return (
      <>
        <MessageEditor id={template} />
        <div className="mt-6 px-4 pb-8">
          <UseInN8nPanel id={template} />
        </div>
      </>
    );
  },
});
